
import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class AuditService {
  readonly endpoints = {
    addAuditEntry: `${environment.apiUrl}/audit/add`
  }

  private http: HttpClient = inject(HttpClient);

  addAuditEntry(body: any): Observable<any> {
    return this.http.post<any>(this.endpoints.addAuditEntry, body);
  }
}
